import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styles from './UserFeedBack.module.scss';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';

const UserFeedBack = ({ setShowFeedBack, createTicketResp }) => {
  const navigate = useNavigate();
  const popupRef = useRef(null);

  useClickAwayListener(popupRef, () => {
    document.body.style.overflow = 'unset';
    setShowFeedBack(false);
    navigate(-1);
  });

  return (
    <section className={`cs_modal ${styles.FeedbackModal} `}>
      <div style={{ width: '90%' }} ref={popupRef} className={`cs_modal_content cs_modal_animation fadeInUpTop `}>
        <div
          aria-label="user_report_feedback_close"
          tabIndex={0}
          role="button"
          onKeyDown={() => {}}
          onClick={() => {
            setShowFeedBack(false);
            navigate(-1);
          }}
          className={`${styles.FeedbackModal__Close_Icon_div} p-10`}
        >
          <img
            className={`${styles.FeedbackModal__Close_Icon}`}
            alt="popup_close"
            src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/modal_close_icon.png"
          />
        </div>
        <div className="cs_modal_body p-20">
          <div className={`${styles.FeedbackModal__Box}`}>
            {createTicketResp !== 'Error' && (
              <img
                alt=""
                className={`${styles.FeedbackModal__BoxImage} mb-30`}
                src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/thnakyou_thumb.svg"
              />
            )}
            <div className="text-center font12 fw500">
              {createTicketResp === 'Error'
                ? 'We are facing an issue while raising your complaint. Please try again in some time or call 8888888888 for your complaint'
                : createTicketResp || ''}
            </div>
            {/* <div className="font12 fw400 color777 mt-30">Your submission has been recieved.</div>
              <div className="font16 fw600 color111 mt-5">We will assist you at the earliest.</div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

UserFeedBack.propTypes = {
  setShowFeedBack: PropTypes.func,
  createTicketResp: PropTypes.string,
};

UserFeedBack.defaultProps = {
  createTicketResp: '',
};

export default UserFeedBack;
